import Vue from 'vue';
import Vuex from 'vuex';


import app from './modules/app';
import user from './modules/user';
import country from './modules/country';
import getters from './modules/getters';
import tagsView from './modules/tagsView';
import rightClick from './modules/rightClick';



Vue.use(Vuex);



export default new Vuex.Store({
  modules: {
    app,
    user,
    country,
    tagsView,
    rightClick
  },
  getters
});



